import * as actionTypes from './actionTypes';

export const openFlashMessage = (message?: string) => ({
  type: actionTypes.OPEN_FLASH_MESSAGE,
  show: true,
  message
});

export const closeFlashMessage = () => ({
  type: actionTypes.CLOSE_FLASH_MESSAGE,
  show: false
});
